import React, { useState } from "react";
import Header from "./Header";

const MonolingualInput = () => {
  const [url, setUrl] = useState("");
  const [error, setError] = useState("");
  const [submittedUrl, setSubmittedUrl] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();

    // Regex to validate Indian government websites (.gov.in or .nic.in)
    const govRegex = /^https?:\/\/([a-zA-Z0-9-]+\.)*(gov\.in|nic\.in)(\/.*)?$/;

    if (!govRegex.test(url.trim())) {
      setError("Please enter a valid Indian government website (ending with .gov.in or .nic.in).");
      setSubmittedUrl(null);
      return;
    }

    setError("");
    setSubmittedUrl(url);
  };

  return (
    <div className="bg-[#fffaf7] min-h-screen relative">
      <Header />

      <div className="flex flex-col items-center justify-center mt-16 px-6">
        <div className="bg-white shadow-lg rounded-2xl p-8 w-full max-w-2xl border border-gray-200">
          <h2 className="text-2xl font-semibold text-gray-800 text-center mb-6">
            🌐 Monolingual Data Input
          </h2>

          <p className="text-gray-600 text-center mb-8 text-sm">
            Please enter the URL of a verified <span className="font-medium">Government of India</span> website.  
            Only domains ending with <span className="font-semibold text-blue-600">.gov.in</span> or <span className="font-semibold text-blue-600">.nic.in</span> are accepted.
          </p>

          <form onSubmit={handleSubmit} className="flex flex-col gap-5">
            <input
              type="text"
              placeholder="Enter Government Website URL (e.g., https://india.gov.in)"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg text-gray-800 text-sm focus:ring-2 focus:ring-orange-400 focus:outline-none"
            />

            {error && (
              <div className="text-red-600 text-sm font-medium text-center -mt-3">{error}</div>
            )}

            <button
              type="submit"
              className="w-full bg-[#ec7026] hover:bg-orange-600 text-white font-semibold py-3 rounded-lg transition-all duration-200 shadow-md"
            >
              Validate & Submit
            </button>
          </form>

          {submittedUrl && (
            <div className="mt-8 bg-green-50 border border-green-200 rounded-lg p-4 text-center">
              <p className="text-green-700 font-medium">
                ✅ Valid Government Website Detected:
              </p>
              <a
                href={submittedUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 font-semibold underline break-all"
              >
                {submittedUrl}
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MonolingualInput;
